
const WindowResizeMixin = {
  data () {
    return {
      windowSize: {
        x: 0,
        y: 0
      }
    }
  },
  methods: {
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    }
  }
}

export default WindowResizeMixin
